import { useCallback } from "react";
import { useHistory } from "react-router";

import { useClubSettings } from "../providers";
import { usePortalRoutes } from "./usePortalRoutes";

export function useRedirectUrl() {
  const { isEmbed } = usePortalRoutes();
  const {
     webSettings ,
  } = useClubSettings();
  const history = useHistory();

  const redirectToCustomizedWebsiteOr = useCallback(
    (alternativeInternalUrl?: string) => {
      const location = isEmbed ? window.top!.location : window.location;
      if (webSettings.redirectUrl) {
        location.href = webSettings.redirectUrl;
        return { result: "REDIRECTED_TO_CUSTOMIZED_REDIRECT_URL" } as const;
      } else if (webSettings.yourWebsiteUrl) {
        location.href = webSettings.yourWebsiteUrl;
        return { result: "REDIRECTED_TO_YOUR_WEBSITE_URL" } as const;
      } else if (alternativeInternalUrl) {
        history.push(alternativeInternalUrl);
        return { result: "REDIRECTED_TO_ALTERNATIVE_INTERNAL_URL" } as const;
      }
      return { result: "NOT_REDIRECT" } as const;
    },
    [history, webSettings.redirectUrl, webSettings.yourWebsiteUrl, isEmbed],
  );
  return { redirectToCustomizedWebsiteOr };
}
